import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyRadioModule as MatRadioModule } from '@angular/material/legacy-radio';

import { MwDateRangePickerComponent } from './date-range-picker.component';
import { MwDateRangePickerLocaleService } from './date-range-picker-locale.service';
import { MwLocaleService } from '@core/services';
import { OverlayModule } from '@angular/cdk/overlay';
import { MwOverlayModule } from '@core/components/overlay';
import {
  DateRangePickerLocaleConfig,
  MW_DATE_RANGE_PICKER_LOCALE_CONFIG,
} from './@models/date-range-picker.locale-config';
import { MwDateRangePickerInputComponent } from './date-range-picker-input/date-range-picker-input.component';
import { MwDateRangePickerService } from './@service/date-range-picker.service';
import { MwDateRangePickerPredefinedRangesService } from './@service/date-range-picker-ranges.service';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
    declarations: [MwDateRangePickerComponent, MwDateRangePickerInputComponent],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        OverlayModule,
        TranslateModule,
        MatRadioModule,
        MatButtonModule,
        MatInputModule,
        MatIconModule,
        MwOverlayModule,
    ],
    providers: [
        MwDateRangePickerService,
        MwDateRangePickerPredefinedRangesService,
    ],
    exports: [MwDateRangePickerInputComponent]
})
export class MwDateRangePickerModule {
  constructor() {}
  static forRoot(
    config: DateRangePickerLocaleConfig = {}
  ): ModuleWithProviders<MwDateRangePickerModule> {
    return {
      ngModule: MwDateRangePickerModule,
      providers: [
        { provide: MW_DATE_RANGE_PICKER_LOCALE_CONFIG, useValue: config },
        {
          provide: MwDateRangePickerLocaleService,
          useClass: MwDateRangePickerLocaleService,
          deps: [MW_DATE_RANGE_PICKER_LOCALE_CONFIG, MwLocaleService],
        },
      ],
    };
  }
}
